export default "__VITE_ASSET__5fffab05__"